<!-- 用户案例 -->
<template>
  <div class="user_story_contianer">
    <header class="story-title" v-scroll-animate="{ animation: 'fadeInUp' }">
      Delauney Provides Full Lifecycle IT Products and Solutions for
      Infrastructure
    </header>
    <div class="wrapper" :style="{ paddingLeft: paddingLeft + 'px' }">
      <footer class="course-arrow">
        <!-- <SamplePagination
          :total="4"
          :pageSize="1"
          :currentPage="currentPage"
          @current-change="handleCurrentChange"
        /> -->
      </footer>
      <div class="user_story_box">
        <div class="left">
          <SamplePagination
            :total="4"
            :pageSize="1"
            :currentPage="currentPage"
            @current-change="handleCurrentChange"
          />
          <aside class="user-story-aside">
            <header
              class="aside-hd"
              v-scroll-animate="{ animation: 'fadeInUp' }"
            >
              {{ carouseList[currentPage - 1].name }}
            </header>
            <p
              class="aside-bd"
              v-scroll-animate="{
                animation: 'fadeInUp',
                delay: 200,
              }"
            >
              {{ carouseList[currentPage - 1].projLogo }}
            </p>
            <p
              class="aside-desc"
              v-scroll-animate="{
                animation: 'fadeInUp',
                delay: 300,
              }"
            >
              {{ carouseList[currentPage - 1].desc }}
            </p>
            <img
              :src="carouseList[currentPage - 1].avatarUrl"
              class="aside-avatar"
              alt=""
              v-scroll-animate="{
                animation: 'fadeInUp',
                delay: 400,
              }"
            />
          </aside>
        </div>
        <div class="right">
          <el-carousel
            indicator-position="none"
            :loop="true"
            arrow="never"
            :autoplay="true"
            :interval="8000"
            height="380px"
            ref="carouse"
            @change="handerChange"
          >
            <el-carousel-item v-for="(item, index) in carouseList" :key="index">
              <article class="user-story-mian">
                <img
                  class="c_img cursor-pointer"
                  :src="item.picUrl"
                  alt="轮播图"
                />
              </article>
              <footer class="user-story-ft">
                <img
                  class="c_img cursor-pointer"
                  :src="item.nextPicUrl"
                  alt="轮播图"
                />
              </footer>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SamplePagination from "@/components/SamplePagination.vue";
import user_story_1 from "@/assets/images/homeImg/user_story1.png";
import user_story_2 from "@/assets/images/homeImg/user_story2.png";
import user_story_3 from "@/assets/images/homeImg/user_story3.png";
import user_story_4 from "@/assets/images/homeImg/user_story4.png";

import user_story_avatar_1 from "@/assets/images/homeImg/user_story_avatar1.png";
import user_story_avatar_2 from "@/assets/images/homeImg/user_story_avatar2.png";
import user_story_avatar_3 from "@/assets/images/homeImg/user_story_avatar3.png";
import user_story_avatar_4 from "@/assets/images/homeImg/user_story_avatar4.png";

export default {
  name: "UserStory",
  components: { SamplePagination },
  data() {
    return {
      currentPage: 1,
      carouseList: [
        {
          id: 1,
          picUrl: user_story_1,
          nextPicUrl: user_story_2,
          avatarUrl: user_story_avatar_1,
          projLogo: "VRROAD",
          title:
            "Delauney Provides Full Lifecycle IT Products and Solutions for Infrastructure",
          name: "Dr. Yuan Fang used",
          desc: "to optimize the traffic sign and marking configuration for the Guangling Hub.",
        },
        {
          id: 2,
          picUrl: user_story_2,
          nextPicUrl: user_story_3,
          avatarUrl: user_story_avatar_2,
          projLogo: "AIROAD",
          linkUrl: "",
          title:
            "Delauney Provides Full Lifecycle IT Products and Solutions for Infrastructure",
          name: "Road design engineer Mr. Chao Yang used",
          desc: "to complete the scheme design for the Xinyang Starting Point Hub.",
        },
        {
          id: 3,
          picUrl: user_story_3,
          nextPicUrl: user_story_4,
          avatarUrl: user_story_avatar_3,
          title:
            "Delauney Provides Full Lifecycle IT Products and Solutions for Infrastructure",
          name: "Measurement supervisor Mr. Du Xueshan used the ",
          projLogo: "Digital Construction Management Platform",
          desc: "to manage part of the construction of the Jiangyin-Jingjiang Yangtze River Tunnel.",
        },
        {
          id: 4,
          picUrl: user_story_4,
          nextPicUrl: user_story_1,
          avatarUrl: user_story_avatar_4,
          title:
            "Delauney Provides Full Lifecycle IT Products and Solutions for Infrastructure",
          name: "Mr. Xiao Zhifan used the",
          projLogo: "Laser Point Cloud Engineering Quantity Calculation System",
          desc: "to complete part of the engineering quantity calculations for the Ningyan Expressway.",
        },
      ],
      screenWidth: 1920,
      paddingLeft: 528, //1920分辨率下左侧的padding值
    };
  },
  computed: {},
  created() {
    console.log("this.carouseList--11", this.carouseList);
  },
  mounted() {
    this.updateSizeDisplay();
    window.addEventListener("resize", () => {
      this.updateSizeDisplay();
    });
  },
  methods: {
    updateSizeDisplay() {
      this.screenWidth =
        document.getElementsByClassName("home_container")[0].clientWidth;
      this.paddingLeft = (this.screenWidth - 1200) / 2;
      console.log("paddingLeft--", this.paddingLeft);
    },
    /*
     * @Description: 打开链接
     * @MethodAuthor:  liulian
     * @Date: 2023-07-26 09:17:29
     * @param: ''
     */
    openUrl(item) {
      if (item.bannerLink) {
        window.open(item.bannerLink, "_blank");
      }
    },
    handerChange(index) {
      this.currentPage = index + 1;
    },
    handleCurrentChange({ pageIndex }) {
      console.log(`当前页: ${pageIndex}`);
      this.currentPage = pageIndex;
      this.$refs.carouse.setActiveItem(this.currentPage - 1);
    },
  },
};
</script>

<style lang="scss">
.user_story_contianer {
  width: 100%;
  height: 634px;
  background: url("../../../assets/images/homeImg/userstory_bg.png") no-repeat
    center;
  background-size: cover;
  padding: 80px 0;
  .story-title {
    margin-bottom: 65px;
    font-weight: bold;
    font-size: 28px;
    color: #ffffff;
    line-height: 42px;
    text-align: center;
    font-style: normal;
  }
  .wrapper {
    // position: relative;
    // padding-left: 18.75%;
    height: 380px;
    .user_story_box {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: flex-start;
      .left {
        width: 510px;
        height: 100%;
        position: relative;
        .samplePage-box {
          position: absolute;
          bottom: 0;
          right: 0;
        }
      }
      .right {
        flex: 1;
        height: 100%;
      }
    }
    .el-carousel__item {
      display: flex;
      height: 380px;
    }
    .course-arrow {
      position: absolute;
      left: 18.75%;
      bottom: 0;
      // width: 100%;
      height: 32px;
      z-index: 100;
      background: transparent;
      .el-pagination button:hover,
      .el-pager li.active,
      .el-pager li:hover {
        color: #0035fb;
      }
      .el-pagination button {
      }
      .el-pagination button:disabled {
        color: #c0c4cc;
        cursor: not-allowed;
      }
    }
    .user-story-aside {
      position: relative;
      min-width: 475px;
      .aside-hd {
        margin-bottom: 12px;
        font-size: 18px;
        color: rgba(255, 255, 255, 0.8);
        line-height: 30px;
        text-align: left;
        font-style: normal;
      }
      .aside-bd {
        margin-bottom: 12px;
        font-weight: bold;
        font-size: 30px;
        color: #fff;
        line-height: 40px;
      }
      .aside-avatar {
        width: 100px;
        height: 100px;
        border-radius: 50%;
        object-fit: cover;
        opacity: 0;
      }
      .aside-desc {
        margin-bottom: 20px;
        max-width: 80%;
        font-size: 18px;
        color: rgba(255, 255, 255, 0.8);
        line-height: 28px;
        text-align: left;
        font-style: normal;
      }
    }
    .user-story-mian {
      flex: 1;
      max-width: 668px;
      margin: 0 60px 0 20px; // margin-left: 16px;
      img {
        width: auto;
        // height: 380px;
        max-height: 100%;
        object-fit: contain;
      }
    }
    .user-story-ft {
      width: 668px;
      height: 100%;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }

  .page-info {
    display: inline-block;
    padding: 0 15px;
    color: #606266;
  }
}
</style>
